import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-space ant-space-vertical" }
const _hoisted_2 = { class: "message-title" }
const _hoisted_3 = { style: {"color":"#999","font-size":"14px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "reply-title" }
const _hoisted_7 = { class: "message-reply-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.replyList, (item, index) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        tag: "div",
        to: {path:'/admin/forum/postsPage/postsContent',query:{'searcharticle':item.ArticleID}},
        class: "ant-row ant-row-space-between ant-row-middle reply",
        key: index
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(item.CreatorName), 1),
              _cache[0] || (_cache[0] = _createTextVNode(" 回复了你的 ")),
              (item.MType=='1')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "帖子"))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, "回复")),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.Title), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.CreateTime), 1)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ], 64))
}